module.exports = __webpack_public_path__ + "static/img/logo.de4df4ba.png";